<template>
	<template v-if="faqs">
		<div class="faq-container">
			<h1 class="faq-container-title">{{ processedTitle }} - FAQ</h1>
			<p class="faq-container-subtitle">
				Read on for some more questions you might be asking...
			</p>
			<div class="faq-wrapper">
				<div
					v-for="(faq, index) in faqs"
					:key="index"
					class="faq-container-content"
				>
					<div class="faq-question-wrapper">
						<p
							class="faq-question"
							:class="{ 'faq-open': faq.isOpen }"
							@click="toggleAnswer(index)"
						>
							{{ faq.question }}
						</p>
					</div>

					<div
						class="faq-content"
						:class="{ 'faq-open': faq.isOpen }"
					>
						<p
							class="faq-answer"
							v-html="faq.answer"
						/>
					</div>
				</div>
			</div>
		</div>
	</template>
	<div v-else />
</template>

<script setup>
const props = defineProps({
	faqs: Array,
	processedTitle: String
});

const toggleAnswer = (index) => {
	props.faqs[index].isOpen = !props.faqs[index].isOpen;
};
</script>

<style lang="scss" scoped>
@import "../assets/utils.scss";

h1 {
	margin-bottom: 16px;
	color: var(--gray-800, #1d2939) !important;
	font-size: 28px !important;
	font-style: normal !important;
	font-weight: 700 !important;
	line-height: 120% !important; /* 28.8px */
	text-align: center !important;
	margin-bottom: 0 !important;
	@include breakpoint(lg) {
		margin-bottom: 24px;
	}
}

.faq-container-subtitle {
	padding-top: 16px;
	padding-bottom: 16px;
	font-size: 16px;
	color: $slate-500;
	border-bottom: 1px solid $slate-100;
}
.faq-container {
	width: auto;
	gap: 24px;
	background-color: white;
	border-radius: 8px;
	padding: 0 12px;
	margin: 0 auto;
	margin-bottom: 100px;
	border: 1px solid $slate-100;
	font-family: "DM Sans", sans-serif;
}

.faq-container-content {
	display: flex;
	flex-direction: column;
	border-bottom: 1px solid #d0d5dd;
}

.faq-container-content:last-child {
	border-bottom: unset;
}

.faq-question-wrapper {
	cursor: pointer;
	padding: 12px 0;
}
.faq-question {
	color: var(--gray-500, #060708);
	font-family: "DM Sans", sans-serif;
	font-size: 18px;
	font-style: normal;
	font-weight: 500;
	line-height: 1.3; /* 29.6px */
	vertical-align: middle;
	display: flex;
	align-items: center;
	gap: 16px;
	@include breakpoint(lg) {
		font-size: 20px;
	}
}

.faq-question:not(.faq-open)::after {
	content: "";
	margin-left: auto;
	color: #1e3a8a;
	display: block;
	background-image: url("/images/CaretDown-black.svg");
	height: 16px;
	width: 16px;
	min-width: 16px;
	background-size: cover;
}

.faq-question.faq-open::after {
	content: "";
	margin-left: auto;
	color: #1e3a8a;
	display: block;
	background-image: url("/images/CaretUp-black.svg");
	height: 16px;
	width: 16px;
	min-width: 16px;
	background-size: cover;
}

.faq-question-link {
	color: blue !important;
}

.faq-answer {
	color: $slate-500;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%; /* 24px */
}

a.faq-answer {
	color: red !important;
}

@media (max-width: 768px) {
	h1 {
		font-size: 26px !important;
		line-height: 110% !important;
	}

	.faq-answer {
		font-size: 16px;
		line-height: 140%; /* 16.8px */
	}
}

.container.px-0 {
	padding-left: 0;
	padding-right: 0;
}

:deep(.price-link) {
	color: #3b82f6;
}

h1.faq-container-title {
	font-size: 20px !important;
	text-align: left !important;
	padding-top: 20px;
	padding-bottom: 20px;
	border-bottom: 1px solid $slate-100;
	@include breakpoint(lg) {
		font-size: 24px !important;
	}
}

.faq-content {
	height: 0;
	overflow: hidden;
}

.faq-content.faq-open {
	height: 100%;
}
</style>
